import clx from 'classnames';
import { Users, CalendarDays, CalendarRange, Sun, UserCheck, UserPlus, ChevronRight } from 'lucide-react';
import HoveredInfoIcon from '../../../Common/HoveredInfoIcon';
import DeltaBadge from './DeltaBadge';
import styles from './HomeInfoCards.module.scss';

const THEME_CONFIG = {
  clients: {
    icon: Users,
    themeClass: styles.clients_theme,
  },
  bookings: {
    icon: CalendarDays,
    themeClass: styles.bookings_theme,
  },
};

const TILE_ICONS = {
  active: UserCheck,
  new: UserPlus,
  week: CalendarRange,
  today: Sun,
};

const formatCount = (count) => {
  if (typeof count !== 'number' || Number.isNaN(count)) return count;
  return count.toLocaleString('it-IT');
};

const HomeStatsCard = ({ card, stopBubbleProps, compact = false }) => {
  const config = THEME_CONFIG[card.cardTheme] || THEME_CONFIG.clients;
  const HeaderIcon = config.icon;
  const [hero, ...secondary] = card.values;

  return (
    <div className={clx(styles.performance_card_inner, config.themeClass)}>
      <div className={styles.performance_header}>
        <div className={styles.performance_header_icon}>
          <HeaderIcon size={18} strokeWidth={2.25} />
        </div>
        <div className={styles.performance_header_text}>
          <span className={styles.performance_title}>{card.cardName}</span>
          {card.subtitle ? (
            <span className={styles.performance_subtitle}>{card.subtitle}</span>
          ) : null}
        </div>
      </div>

      {hero ? (
        <div className={styles.performance_hero}>
          <div className={styles.performance_hero_top}>
            <span className={styles.performance_metric_label}>{hero.title}</span>
            {!compact ? (
              <div {...stopBubbleProps}>
                <HoveredInfoIcon description={hero.infoDescription} />
              </div>
            ) : null}
          </div>
          <div className={styles.performance_hero_row}>
            <span className={styles.performance_hero_value}>{formatCount(hero.count)}</span>
            <DeltaBadge
              value={hero.value}
              isPercent={hero.isPercent}
              positive={hero.positive}
              hint={hero.deltaHint}
              stopBubbleProps={stopBubbleProps}
            />
          </div>
        </div>
      ) : null}

      <div className={styles.performance_grid}>
        {secondary.map((metric) => {
          const Icon = TILE_ICONS[metric.id] || config.icon;
          return (
            <div key={metric.title} className={styles.performance_tile}>
              <div className={styles.performance_tile_head}>
                <span className={styles.performance_tile_icon}>
                  <Icon size={14} strokeWidth={2.25} />
                </span>
                <span className={styles.performance_metric_label}>{metric.title}</span>
                {!compact ? (
                  <div {...stopBubbleProps}>
                    <HoveredInfoIcon description={metric.infoDescription} />
                  </div>
                ) : null}
              </div>
              <div className={styles.performance_tile_row}>
                <span className={styles.performance_tile_value}>
                  {formatCount(metric.count)}
                </span>
                <DeltaBadge
                  value={metric.value}
                  isPercent={metric.isPercent}
                  positive={metric.positive}
                  hint={metric.deltaHint}
                  stopBubbleProps={stopBubbleProps}
                />
              </div>
            </div>
          );
        })}
      </div>

      {card.footerCta ? (
        <div className={styles.performance_footer}>
          <span>{card.footerCta.replace(/\s*→\s*$/, '')}</span>
          <ChevronRight size={14} strokeWidth={2.5} aria-hidden="true" />
        </div>
      ) : null}
    </div>
  );
};

export default HomeStatsCard;
